import { basicStyle, parallaxStyle } from './styles'
import { isEmpty } from 'lodash'

const INITIAL_DATA = { containerStyles: '', backgroundStyle: {}, isDesktop: true }

export const getBgImage = ({ isMobile, isTablet, background }) => {
  let property = 'bg_image'

  if (isMobile) {
    property = 'bg_image_mobile'
  } else if (isTablet) {
    property = 'bg_image_tablet'
  } else {
    property = 'bg_image'
  }

  const imageUrl = background[property]?.url

  return `url('${imageUrl}')`
}

export const getBgPosition = ({ isMobile, isTablet, background }) => {
  let property = 'bg_position'

  if (isMobile) {
    property = 'bg_position_mobile'
  } else if (isTablet) {
    property = 'bg_position_tablet'
  } else {
    property = 'bg_position'
  }

  const bgPosition = background[property]

  return bgPosition
}

export const getHeroData = ({ data, isMobile, isTablet, isDesktop }) => {
  if (isEmpty(data)) return INITIAL_DATA

  const parallax = data?.background?.parallax

  const containerStyles = parallax ? parallaxStyle : basicStyle

  const bgImage = getBgImage({ isMobile, isTablet, background: data?.background })
  const backgroundPosition = getBgPosition({ isMobile, isTablet, background: data?.background })

  const backgroundStyle = {
    backgroundImage: bgImage,
    backgroundPosition,
    display: 'grid',
    gridTemplateRows: '1fr',
  }

  return { containerStyles, backgroundStyle, isDesktop }
}

export const getValue = (value) => {
  if (!value) return ''

  return value
}
